module.exports = __webpack_public_path__ + "img/opened-menu.36bfe049.svg";